var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDSignalCoolingPumpStaged1 = function SvgDSignalCoolingPumpStaged1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 350,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,340c5.51,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M18,339c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z",
    fill: "#1c9d5b"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "16.53 354.04 16.53 350.11 20.46 350.11 20.46 346.18 23.88 346.18 23.88 345.18 19.46 345.18 19.46 349.11 15.53 349.11 15.53 353.04 12.6 353.04 12.6 343.71 11.6 343.71 11.6 356 23.88 356 23.88 355 12.6 355 12.6 354.04 16.53 354.04"
  })))));
};
export default SvgDSignalCoolingPumpStaged1;